<template>
  <div class="container-fluid p-4 shadow-sm rounded">

    <!-- ENCABEZADO -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white fw-bold py-1">
        <span>Guía de Remisión</span>
      </div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Emisión</label>
            <input type="date" class="form-control form-control-sm" v-model="cabecera.fechaEmision" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Punto Emisión</label>
            <select class="form-select form-select-sm" v-model="cabecera.puntoEmisionId" :disabled="cargandoPuntos">
              <option v-if="cargandoPuntos" disabled value="">Cargando...</option>
              <option v-else-if="puntosEmision.length === 0" disabled value="">Sin puntos</option>
              <option v-for="p in puntosEmision" :key="p.id" :value="p.id">{{ p.full_code }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Ambiente</label>
            <input type="text" class="form-control form-control-sm" v-model="cabecera.ambiente" disabled />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Secuencial</label>
            <input
              type="text"
              class="form-control form-control-sm"
              :value="cargandoSecuencial ? 'Cargando...' : (secuencial || 'Sin secuencial')"
              disabled
            />
          </div>
        </div>
      </div>
    </div>

    <!-- TRANSPORTISTA -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white fw-bold py-1">Transportista</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-2">
            <label class="form-label small mb-1">Tipo Identificación</label>
            <select class="form-select form-select-sm" v-model="transportista.tipoIdentificacion">
              <option value="04">RUC</option>
              <option value="05">Cédula</option>
              <option value="06">Pasaporte</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label small mb-1">RUC / Identificación Transportista</label>
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="RUC del transportista"
                v-model="transportista.ruc"
                @blur="buscarTransportista"
                @keyup.enter="buscarTransportista"
              />
              <span v-if="buscandoTransportista" class="input-group-text">
                <span class="spinner-border spinner-border-sm"></span>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label small mb-1">Razón Social</label>
            <input type="text" class="form-control form-control-sm" v-model="transportista.razonSocial" placeholder="Razón social del transportista" />
          </div>
          <div class="col-md-2">
            <label class="form-label small mb-1">Placa del Vehículo</label>
            <input type="text" class="form-control form-control-sm" v-model="transportista.placa" placeholder="Ej: ABC-1234" maxlength="10" />
          </div>
        </div>
      </div>
    </div>

    <!-- DATOS DEL TRASLADO -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white fw-bold py-1">Datos del Traslado</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Inicio Transporte</label>
            <input type="date" class="form-control form-control-sm" v-model="traslado.fechaInicio" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Fin Transporte</label>
            <input type="date" class="form-control form-control-sm" v-model="traslado.fechaFin" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Dirección de Partida</label>
            <input type="text" class="form-control form-control-sm" v-model="traslado.direccionPartida" placeholder="Dirección desde donde parten las mercancías" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Motivo del Traslado</label>
            <input type="text" class="form-control form-control-sm" v-model="traslado.motivo" placeholder="Ej: Traslado de mercancías por venta" />
          </div>
        </div>
      </div>
    </div>

    <!-- DESTINATARIOS Y DETALLES -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white fw-bold py-1 d-flex justify-content-between align-items-center">
        <span>Destinatarios y Mercancías</span>
        <button class="btn btn-light btn-sm" @click="agregarDestinatario">+ Agregar Destinatario</button>
      </div>
      <div class="card-body py-2">
        <div v-for="(dest, idx) in destinatarios" :key="idx" class="border rounded p-3 mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h6 class="mb-0 text-primary">Destinatario {{ idx + 1 }}</h6>
            <button v-if="destinatarios.length > 1" class="btn btn-outline-danger btn-sm" @click="eliminarDestinatario(idx)">ðŸ—‘ï¸ Eliminar</button>
          </div>
          <div class="row gy-2 mb-2">
            <div class="col-md-4">
              <label class="form-label small mb-1">Identificación</label>
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="dest.identificacion"
                  placeholder="RUC / Cédula"
                  @blur="buscarClienteDestinatario(idx, 'identificacion')"
                  @keyup.enter="buscarClienteDestinatario(idx, 'identificacion')"
                />
                <span v-if="dest.buscandoCliente" class="input-group-text">
                  <span class="spinner-border spinner-border-sm"></span>
                </span>
              </div>
            </div>
            <div class="col-md-5">
              <label class="form-label small mb-1">Razón Social</label>
              <div class="position-relative">
                <div class="input-group input-group-sm">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="dest.razonSocial"
                    placeholder="Nombre del destinatario"
                    @input="sugerirClienteDestinatario(idx)"
                    @blur="cerrarSugerenciasDestinatario(idx)"
                    @keydown.down.prevent="navegarSugerenciaDestinatario(idx, 1)"
                    @keydown.up.prevent="navegarSugerenciaDestinatario(idx, -1)"
                    @keydown.enter.prevent="seleccionarSugerenciaActivaDestinatario(idx)"
                    @keydown.escape="cerrarSugerenciasDestinatario(idx)"
                    autocomplete="off"
                  />
                  <span v-if="dest.buscandoCliente" class="input-group-text">
                    <span class="spinner-border spinner-border-sm"></span>
                  </span>
                </div>
                <ul
                  v-if="dest.sugerenciasClientes.length > 0 && dest.mostrarSugerencias"
                  class="list-group position-absolute w-100 shadow-sm sugerencias-lista"
                >
                  <li
                    v-for="(cli, cidx) in dest.sugerenciasClientes"
                    :key="cli.id"
                    class="list-group-item list-group-item-action py-1 px-2 small"
                    :class="{ 'active': cidx === dest.indiceSugerenciaActiva }"
                    @mousedown.prevent="seleccionarClienteDestinatario(idx, cli)"
                  >
                    <div class="fw-semibold">{{ cli.business_name }}</div>
                    <small class="text-muted">{{ cli.identification_number }}</small>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label small mb-1">Motivo traslado destino</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.motivoTraslado" placeholder="Motivo" />
            </div>
            <div class="col-12">
              <label class="form-label small mb-1">Dirección de Destino</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.direccion" placeholder="Dirección del destinatario" />
            </div>
            <div class="col-md-6">
              <label class="form-label small mb-1">Ruta (opcional)</label>
              <input type="text" class="form-control form-control-sm" v-model="dest.ruta" placeholder="Ruta de transporte" />
            </div>
          </div>

          <!-- Buscador de producto del destinatario -->
          <div class="row mb-2">
            <div class="col-12">
              <label class="form-label small mb-1">Buscar Producto</label>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Escribe código o nombre del bien..."
                v-model="dest.productSearchQuery"
                @input="onProductSearchInputDestinatario(idx)"
                @keyup.enter="buscarProductoDestinatario(idx)"
              />
              <div v-if="dest.loadingProductSearch" class="mt-1">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </div>
              <ul v-if="dest.productSuggestions.length" class="list-group mt-1 border" style="max-height:200px;overflow-y:auto;position:relative;z-index:50;">
                <li
                  v-for="p in dest.productSuggestions"
                  :key="p.id"
                  @click="selectProductoDestinatario(idx, p)"
                  class="list-group-item list-group-item-action small border-0"
                  style="cursor:pointer;"
                >
                  <strong>{{ p.codigo_principal }}</strong> - {{ p.nombre_producto }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Detalles (productos) del destinatario -->
          <div class="table-responsive mb-2">
            <table class="table table-sm table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Código</th>
                  <th style="min-width:200px">Descripción</th>
                  <th style="width:100px">Cantidad</th>
                  <th style="width:80px">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(det, dIdx) in dest.detalles" :key="dIdx">
                  <td><input type="text" class="form-control form-control-sm" v-model="det.codigo" placeholder="Código" /></td>
                  <td><input type="text" class="form-control form-control-sm" v-model="det.descripcion" placeholder="Descripción del bien" /></td>
                  <td><input type="number" class="form-control form-control-sm text-end" v-model.number="det.cantidad" min="0.01" step="0.01" /></td>
                  <td class="text-center"><button class="btn btn-outline-danger btn-sm" @click="eliminarDetalle(idx, dIdx)">ðŸ—‘ï¸</button></td>
                </tr>
                <tr v-if="dest.detalles.length === 0">
                  <td colspan="4" class="text-center text-muted small fst-italic">Sin detalles. Agrega al menos uno.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button class="btn btn-outline-primary btn-sm" @click="agregarDetalle(idx)">+ Agregar ítem</button>
        </div>
      </div>
    </div>

    <!-- OBSERVACIONES -->
    <div class="card mb-4">
      <div class="card-header bg-primary text-white fw-bold py-1">Observaciones</div>
      <div class="card-body py-2">
        <textarea class="form-control form-control-sm" rows="3" v-model="observaciones" placeholder="Observaciones adicionales (opcional)"></textarea>
      </div>
    </div>

    <!-- ACCIONES -->
    <div class="d-flex gap-2 justify-content-end">
      <router-link to="/ventas/documentos-emitidos" class="btn btn-outline-secondary">Cancelar</router-link>
      <button class="btn btn-outline-primary" @click="guardar(false)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Guardar Borrador
      </button>
      <button class="btn btn-primary" @click="guardar(true)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Emitir Guía
      </button>
    </div>

    <!-- ALERTA -->
    <div v-if="alerta.mensaje" :class="`alert alert-${alerta.tipo} mt-3`" role="alert">
      {{ alerta.mensaje }}
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import { mapGetters } from 'vuex'

function hoy() {
  const now = new Date()
  const ec = new Date(now.getTime() + -5 * 60 * 60 * 1000)
  return ec.toISOString().slice(0, 10)
}

export default {
  name: 'ClientGuiaRemision',

  data() {
    return {
      cabecera: {
        fechaEmision: hoy(),
        puntoEmisionId: '',
        ambiente: '',
      },
      secuencial: '',
      cargandoSecuencial: false,
      puntosEmision: [],
      cargandoPuntos: false,

      transportista: {
        ruc: '',
        tipoIdentificacion: '04',
        razonSocial: '',
        placa: '',
      },
      buscandoTransportista: false,

      traslado: {
        fechaInicio: hoy(),
        fechaFin: hoy(),
        direccionPartida: '',
        motivo: '',
      },

      destinatarios: [
        {
          identificacion: '',
          razonSocial: '',
          direccion: '',
          ruta: '',
          motivoTraslado: '',
          buscandoCliente: false,
          sugerenciasClientes: [],
          mostrarSugerencias: false,
          indiceSugerenciaActiva: -1,
          productSearchQuery: '',
          productSuggestions: [],
          loadingProductSearch: false,
          detalles: [{ codigo: '', descripcion: '', cantidad: 1 }],
        },
      ],

      observaciones: '',
      debounceTimers: {},
      procesando: false,
      alerta: { mensaje: '', tipo: 'danger' },
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
  },

  watch: {
    'cabecera.puntoEmisionId': {
      async handler(nuevoId) {
        if (nuevoId) await this.cargarSecuencial(nuevoId)
      },
    },
  },

  async mounted() {
    await Promise.all([this.cargarPuntosEmision(), this.cargarAmbiente()])
  },

  methods: {
    async cargarPuntosEmision() {
      this.cargandoPuntos = true
      try {
        const { data } = await api.get('/configuracion/puntos-activos')
        this.puntosEmision = data.data || []
        if (this.puntosEmision.length > 0) {
          const principal = this.puntosEmision.find(p => p.is_main)
          this.cabecera.puntoEmisionId = (principal || this.puntosEmision[0]).id
        }
      } catch (e) {
        console.error('Error al cargar puntos de emisión:', e)
      } finally {
        this.cargandoPuntos = false
      }
    },

    async cargarSecuencial(puntoId) {
      this.cargandoSecuencial = true
      try {
        const { data } = await api.get('/configuracion/secuencial/next', {
          params: { eep_id: puntoId, document_type: '06' }
        })
        if (data.success && data.data) {
          this.secuencial = String(data.data.sequence).padStart(9, '0')
        }
      } catch (e) {
        console.error('Error al cargar secuencial:', e)
        this.secuencial = '000000001'
      } finally {
        this.cargandoSecuencial = false
      }
    },

    async cargarAmbiente() {
      try {
        const { data } = await api.get('/configuracion/ambiente-sri')
        if (data.success && data.data) {
          this.cabecera.ambiente = data.data.nombre
        }
      } catch (e) {
        console.error('Error al cargar ambiente:', e)
      }
    },

    async buscarTransportista() {
      const ruc = this.transportista.ruc.trim()
      if (ruc.length < 10) return
      this.buscandoTransportista = true
      try {
        const { data } = await api.get(`/sri/ruc-catastro/${ruc}`)
        if (data.razon_social || data.nombre_comercial) {
          this.transportista.razonSocial = data.razon_social || data.nombre_comercial
        }
      } catch (e) {
        // Si no se encuentra, el usuario escribe manualmente
      } finally {
        this.buscandoTransportista = false
      }
    },

    agregarDestinatario() {
      this.destinatarios.push({
        identificacion: '',
        razonSocial: '',
        direccion: '',
        ruta: '',
        motivoTraslado: '',
        buscandoCliente: false,
        sugerenciasClientes: [],
        mostrarSugerencias: false,
        indiceSugerenciaActiva: -1,
        productSearchQuery: '',
        productSuggestions: [],
        loadingProductSearch: false,
        detalles: [{ codigo: '', descripcion: '', cantidad: 1 }],
      })
    },

    eliminarDestinatario(idx) {
      this.destinatarios.splice(idx, 1)
    },

    agregarDetalle(destIdx) {
      this.destinatarios[destIdx].detalles.push({ codigo: '', descripcion: '', cantidad: 1 })
    },

    eliminarDetalle(destIdx, detIdx) {
      this.destinatarios[destIdx].detalles.splice(detIdx, 1)
    },

    validar() {
      if (!this.cabecera.puntoEmisionId) return 'Seleccione un punto de emisión.'
      if (!this.transportista.ruc.trim()) return 'Ingrese el RUC del transportista.'
      if (!this.transportista.razonSocial.trim()) return 'Ingrese la razón social del transportista.'
      if (!this.transportista.placa.trim()) return 'Ingrese la placa del vehículo.'
      if (!this.traslado.direccionPartida.trim()) return 'Ingrese la dirección de partida.'
      if (!this.traslado.motivo.trim()) return 'Ingrese el motivo del traslado.'
      for (const dest of this.destinatarios) {
        if (!dest.razonSocial.trim()) return 'Complete la razón social de todos los destinatarios.'
        if (!dest.direccion.trim()) return 'Complete la dirección de todos los destinatarios.'
        if (dest.detalles.length === 0) return 'Cada destinatario debe tener al menos un detalle.'
        for (const det of dest.detalles) {
          if (!det.descripcion.trim()) return 'Complete la descripción de todos los detalles.'
          if (!det.cantidad || det.cantidad <= 0) return 'La cantidad debe ser mayor a 0.'
        }
      }
      return null
    },

    async guardar(emitir) {
      this.alerta = { mensaje: '', tipo: 'danger' }
      const error = this.validar()
      if (error) {
        this.alerta = { mensaje: error, tipo: 'warning' }
        return
      }

      this.procesando = true
      try {
        const payload = {
          intent: emitir ? 'ISSUE' : 'DRAFT',
          punto_emision_id: this.cabecera.puntoEmisionId,
          fecha_emision: this.cabecera.fechaEmision,
          ruc_transportista: this.transportista.ruc,
          tipo_identificacion_transportista: this.transportista.tipoIdentificacion,
          razon_social_transportista: this.transportista.razonSocial,
          placa: this.transportista.placa,
          fecha_inicio_transporte: this.traslado.fechaInicio,
          fecha_fin_transporte: this.traslado.fechaFin,
          direccion_partida: this.traslado.direccionPartida,
          motivo_traslado: this.traslado.motivo,
          observaciones: this.observaciones || null,
          destinatarios: this.destinatarios.map(d => ({
            identificacion_destinatario: d.identificacion,
            razon_social_destinatario: d.razonSocial,
            direccion_destinatario: d.direccion,
            ruta: d.ruta || null,
            motivo_traslado: d.motivoTraslado || null,
            detalles: d.detalles.map(det => ({
              codigo_principal: det.codigo,
              descripcion: det.descripcion,
              cantidad: det.cantidad,
            })),
          })),
        }

        const { data } = await api.post('/guias-remision', payload)
        if (data.success) {
          this.alerta = { mensaje: emitir ? 'Guía emitida correctamente.' : 'Borrador guardado correctamente.', tipo: 'success' }
          setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 1500)
        } else {
          this.alerta = { mensaje: data.error || 'Error al procesar la guía.', tipo: 'danger' }
        }
      } catch (e) {
        this.alerta = { mensaje: e.response?.data?.error || 'Error al conectar con el servidor.', tipo: 'danger' }
      } finally {
        this.procesando = false
      }
    },

    async buscarClienteDestinatario(idx, tipoBusqueda) {
      const dest = this.destinatarios[idx]
      const valor = tipoBusqueda === 'identificacion' ? dest.identificacion?.trim() : dest.razonSocial?.trim()
      if (!valor || valor.length < 3) return
      dest.buscandoCliente = true
      try {
        const { data } = await api.get('/clientes/buscar', { params: { q: valor, tipo: tipoBusqueda } })
        if (data.success && data.data) {
          const c = data.data
          dest.identificacion = c.identification_number || c.numero_ruc || dest.identificacion
          dest.razonSocial = c.business_name || c.razon_social || dest.razonSocial
          dest.direccion = c.address || c.direccion_matriz || dest.direccion
        }
      } catch (e) {
        console.log('Destinatario no encontrado:', e.response?.data?.message || e.message)
      } finally {
        dest.buscandoCliente = false
      }
    },

    sugerirClienteDestinatario(idx) {
      const dest = this.destinatarios[idx]
      const query = dest.razonSocial?.trim()
      if (this.debounceTimers[idx]) clearTimeout(this.debounceTimers[idx])
      if (!query || query.length < 2) {
        dest.sugerenciasClientes = []
        dest.mostrarSugerencias = false
        return
      }
      this.debounceTimers[idx] = setTimeout(async () => {
        dest.buscandoCliente = true
        try {
          const { data } = await api.get('/clientes/autocompletar', { params: { q: query, limit: 8 } })
          if (data.success && data.data) {
            dest.sugerenciasClientes = data.data
            dest.mostrarSugerencias = true
            dest.indiceSugerenciaActiva = -1
          } else {
            dest.sugerenciasClientes = []
          }
        } catch (e) {
          dest.sugerenciasClientes = []
        } finally {
          dest.buscandoCliente = false
        }
      }, 300)
    },

    seleccionarClienteDestinatario(idx, cliente) {
      const dest = this.destinatarios[idx]
      dest.identificacion = cliente.identification_number || cliente.numero_ruc || ''
      dest.razonSocial = cliente.business_name || ''
      dest.direccion = cliente.address || cliente.direccion_matriz || dest.direccion
      this.cerrarSugerenciasDestinatario(idx)
    },

    cerrarSugerenciasDestinatario(idx) {
      setTimeout(() => {
        const dest = this.destinatarios[idx]
        dest.sugerenciasClientes = []
        dest.mostrarSugerencias = false
        dest.indiceSugerenciaActiva = -1
      }, 200)
    },

    navegarSugerenciaDestinatario(idx, direccion) {
      const dest = this.destinatarios[idx]
      if (!dest.mostrarSugerencias) return
      const max = dest.sugerenciasClientes.length - 1
      dest.indiceSugerenciaActiva = Math.max(-1, Math.min(max, dest.indiceSugerenciaActiva + direccion))
    },

    seleccionarSugerenciaActivaDestinatario(idx) {
      const dest = this.destinatarios[idx]
      if (dest.indiceSugerenciaActiva >= 0 && dest.sugerenciasClientes[dest.indiceSugerenciaActiva]) {
        this.seleccionarClienteDestinatario(idx, dest.sugerenciasClientes[dest.indiceSugerenciaActiva])
      }
    },

    onProductSearchInputDestinatario(idx) {
      const dest = this.destinatarios[idx]
      if (this.debounceTimers[`prod_${idx}`]) clearTimeout(this.debounceTimers[`prod_${idx}`])
      const query = (dest.productSearchQuery || '').trim()
      if (query.length >= 2) {
        this.debounceTimers[`prod_${idx}`] = setTimeout(() => { this.buscarProductoDestinatario(idx) }, 500)
      } else {
        dest.productSuggestions = []
      }
    },

    async buscarProductoDestinatario(idx) {
      const dest = this.destinatarios[idx]
      const query = (dest.productSearchQuery || '').trim()
      if (!query) return
      dest.loadingProductSearch = true
      try {
        const res = await api.get('/productos', {
          params: { filtros: JSON.stringify({ busqueda: query }), limit: 15, offset: 0 }
        })
        const list = res.data?.data?.productos || res.data?.productos || (Array.isArray(res.data?.data) ? res.data.data : [])
        if (list.length) {
          const queryUpper = query.toUpperCase()
          const exacto = list.find(
            p => (p.codigo_principal || '').toUpperCase() === queryUpper ||
                 (p.codigo_auxiliar  || '').toUpperCase() === queryUpper
          )
          if (exacto) {
            this.selectProductoDestinatario(idx, exacto)
            return
          }
          dest.productSuggestions = list
        } else {
          dest.productSuggestions = []
        }
      } catch (e) {
        console.error('Error al buscar producto:', e)
        dest.productSuggestions = []
      } finally {
        dest.loadingProductSearch = false
      }
    },

    selectProductoDestinatario(idx, p) {
      const dest = this.destinatarios[idx]
      dest.detalles.push({
        codigo: p.codigo_principal || '',
        descripcion: p.nombre_producto || '',
        cantidad: 1,
      })
      dest.productSearchQuery = ''
      dest.productSuggestions = []
    },
  },
}
</script>

<style scoped>
.sugerencias-lista {
  top: 100%;
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-main, #e2e8f0);
  background-color: var(--secondary-bg-main, #fff);
}
</style>

